import { useMutation } from "@tanstack/react-query"
import { saveAs } from "file-saver"
import { useTranslation } from "react-i18next"
import { toast } from "sonner"

import { exportExcelApi } from "@/api/api"
import { SettingsService } from "@/services/settings-service"

import { useAIParserSession } from "./use-ai-parser-session"

async function exportExcel(sessionId: string): Promise<Blob> {
  const settingsService = SettingsService.getInstance()

  const response = await exportExcelApi(settingsService.token, sessionId)
  return await response.blob()
}

type UseExportMutationProps = {
  filename?: string
}

const DEFAULT_FILENAME = "ai-parser-export" as const

export function useExportMutation(
  { filename }: UseExportMutationProps = { filename: DEFAULT_FILENAME }
) {
  const { t } = useTranslation()
  const { currentSessionId } = useAIParserSession()

  return useMutation({
    mutationFn: () => exportExcel(currentSessionId ?? ""),
    onSuccess: (blob) => {
      saveAs(blob, `${filename ?? DEFAULT_FILENAME}.xlsx`)
      toast.success(t("pages.ai_parser.toasts.excel_download_started"))
    },
  })
}
